import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEndCustomerPaid } from "Context/EndCustomerPaid";
import { useEffect, useState } from "react";

const BundleSelect = () => {
  const { bundles, selectedBundleId, setSelectedBundleId, fetchAllBundles } =
    useEndCustomerPaid();
  const [filteredBundles, setFilteredBundles] = useState([]);

  useEffect(() => {
    fetchAllBundles();
  }, []);

  useEffect(() => {
    const tmpFilteredBundles = bundles.filter((b1) => b1.SystemStatus === "1");
    if (tmpFilteredBundles.length > 0) {
      const firstBundle = tmpFilteredBundles.sort(
        (b1, b2) => new Date(b2.CreateTime) - new Date(b1.CreateTime)
      )[0];
      if (firstBundle) {
        setSelectedBundleId(firstBundle.Id);
      }
    }
    setFilteredBundles(tmpFilteredBundles);
  }, [bundles]);

  return (
    <FormControl margin="dense" fullWidth size="small" sx={{ textAlign: "left" }}>
      <InputLabel>Bunt</InputLabel>
      <Select
        name="Bunt"
        value={selectedBundleId ?? ""}
        onChange={(e) => setSelectedBundleId(e.target.value)}
        label="Bunt"
        sx={{ background: "white" }}
      >
        {filteredBundles
          .sort((b1, b2) => new Date(b2.CreateTime) - new Date(b1.CreateTime))
          .map((bundle) => (
            <MenuItem key={bundle.Id} value={bundle.Id}>
              {bundle.FileName}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default BundleSelect;
